import { request } from '@koi-design/vix-tools';
import { prefixApi } from './urls';
// 图表转图片接口
export const convertChartToImageApi = async (data: FormData) => {
  return request({
    url: `${prefixApi}/copilot/getTempMediaUrl`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 获取图表图片ID
export const getChartImageIdApi = async (imageId: string) => {
  return request({
    url: `/api/chart/image/${imageId}`,
    method: 'GET'
  });
};
